module.exports = __webpack_public_path__ + "img/activities.0960a8b2.svg";